import {Container, Row, Col, Tabs, Tab, ProgressBar} from 'react-bootstrap';
import React, {Component} from 'react';
import InfoIcon from '@material-ui/icons/Info';
import {Tooltip} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import {namedEntitiesLabels} from "../utils/constants";


class ExtractionResults extends Component {

    state = {
        activeItem: "1",
    }

    toggle = tab => e => {
        if (this.state.activeItem !== tab) {
            this.setState({
                activeItem: tab
            });
        }
    };

    render() {
        return (
            <Container fluid style={{padding: 0, marginTop: '10px'}}>
                <h5 className="extraction-results">Extraction Results</h5>
                <Tabs defaultActiveKey="entities">
                    {/*<Tab eventKey="concepts" title={<Badge badgeContent={this.props.concepts.length} color="primary">Concepts</Badge>}>*/}
                    <Tab eventKey="entities" title="Named Entities">
                        <Row className="header-row">
                            <Col>{namedEntitiesLabels[this.props.namedEntityType]} <Tooltip title={
                                <Typography>
                                    <strong>(Named) entity recognition (NER)</strong> relies on machine learning to detect mentions of a particular entity type: Person names, organisations, locations, etc. It is <strong>not limited to a list of known names</strong>, and is based primarily on the context of word use. Rule-based recognition relies on heuristics instead of machine learning.<br/>
                                    Our custom entity recognisers were trained without a hand-annotated corpus, using a custom process <strong>bootstrapped from a domain vocabulary (taxonomy)</strong>.
                                </Typography>
                            }><InfoIcon style={{ color: '#00adee' }}/></Tooltip></Col>
                            <Col>Score</Col>
                            <Col>Frequency</Col>
                        </Row>
                        {this.props.namedEntities.length > 0 ? (
                                this.props.namedEntities.map((entity, index) => {
                                    return (
                                        <Row key={index}>
                                            <Col> {entity.entity}</Col>
                                            <Col><ProgressBar now={entity.score}></ProgressBar></Col>
                                            <Col>{entity.frequency}</Col>
                                        </Row>
                                    )
                                })
                            ) : "No Results"}
                    </Tab>
                    <Tab eventKey="concepts" title="Concepts">
                        <Row className="header-row">
                            <Col>Concept (MESH 2019 Diseases) <Tooltip title={
                                <Typography>
                                    <strong>Concept extraction</strong> matches words or phrases against <strong>a known vocabulary (taxonomy)</strong>. Disambiguation is based on proximity to related concepts.
                                </Typography>
                            }><InfoIcon style={{ color: '#00adee' }}/></Tooltip></Col>
                            <Col>Score</Col>
                            <Col>Frequency</Col>
                        </Row>
                        {
                            this.props.concepts ? (this.props.concepts.length > 0 ? (
                                this.props.concepts.map((concept, index) => {
                                    return (
                                        <Row key={index}>
                                            <Col>
                                                <a className="pp-link" href={concept.uri} target="_blank" rel="noopener noreferrer">{concept.concept}</a>
                                             </Col>
                                            <Col><ProgressBar now={concept.score}></ProgressBar></Col>
                                            <Col>{concept.frequency}</Col>
                                        </Row>
                                    )
                                })
                            ) : "No Results") : ""
                        }
                    </Tab>
                    <Tab eventKey="terms" title="Important Terms">
                        <Row className="header-row">
                            <Col>Term <Tooltip title={
                                <Typography>
                                    <strong>Important terms</strong> are words or phrases that are not known vocabulary items, but were identified by text analysis algorithms as potentially important — and hence as candidates for addition to the taxonomy. Analysis requires a relatively large amount of text.
                                </Typography>
                            }><InfoIcon style={{ color: '#00adee' }}/></Tooltip></Col>
                            <Col>Score</Col>
                            <Col>Frequency</Col>
                        </Row>
                        {
                            this.props.terms ? (this.props.terms.length > 0 ? (
                                this.props.terms.map((term, index) => {
                                    return (
                                        <Row key={index}>
                                            <Col> {term.term}</Col>
                                            <Col><ProgressBar now={term.score}></ProgressBar></Col>
                                            <Col>{term.frequency}</Col>
                                        </Row>
                                    )
                                })
                            ) : "No Results") : ""
                        }
                    </Tab>
                    <Tab eventKey="classifier" title={"Document Classification"}>
                        <Row className="header-row">
                            <Col>Document Genre <Tooltip title={
                                <Typography>
                                    <strong>Document classification</strong> chooses among a set of categories for the document as a whole. PoolParty classifiers are trained with a variety of machine-learning algorithms. This one chooses between "medical journal abstract" and "news article", and was trained with the Random Forest algorithm.
                                </Typography>
                            }><InfoIcon style={{ color: '#00adee' }}/></Tooltip></Col>
                        </Row>
                        <Row className="classifier-row">
                            <Col>
                                The submitted text was classified as <strong>{this.props.classifier}</strong>.
                            </Col>
                        </Row>
                    </Tab>
                </Tabs>
            </Container>
        )
    }
}

export default ExtractionResults;